import classNames from 'classnames';
import styles from './skeleton-loader.module.scss';

export interface SkeletonLoaderProps {
  /** Border radius of the skeleton loader */
  borderRadius?: string;
  /** The class name to apply */
  className?: string;
  /** Height of the skeleton loader */
  height?: string;
  /** Width of the skeleton loader */
  width?: string;
}

const SkeletonLoader = ({
  borderRadius,
  className,
  height,
  width,
}: SkeletonLoaderProps) => {
  return (
    <div
      className={classNames(styles.component, className)}
      style={{
        borderRadius,
        height,
        width,
      }}
    />
  );
};

SkeletonLoader.displayName = 'SkeletonLoader';

export default SkeletonLoader;
